import React, { useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { activities as allActivities } from '../data/activities';
import type { ChannelFilter, Density } from '../types/ui';
import { TimelineToolbar } from '../components/timeline/TimelineToolbar';
import { TimelineList } from '../components/timeline/TimelineList';
import { ActivityDetail } from '../components/timeline/ActivityDetail';
import { groupTimeline } from '../utils/timeline';
interface ActivityTimelineProps {
  density: Density;
}
export function ActivityTimeline({
  density
}: ActivityTimelineProps) {
  const [filter, setFilter] = useState<ChannelFilter>('all');
  const [query, setQuery] = useState('');
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const counts = useMemo(() => {
    const base: Record<ChannelFilter, number> = {
      all: allActivities.length,
      call: 0,
      sms: 0,
      email: 0,
      event: 0
    };
    allActivities.forEach(activity => {
      base[activity.channel] += 1;
    });
    return base;
  }, []);
  const visible = useMemo(() => {
    const needle = query.trim().toLowerCase();
    return allActivities.filter(activity => {
      if (filter !== 'all' && activity.channel !== filter) return false;
      if (!needle) return true;
      return activity.title.toLowerCase().includes(needle) || activity.summary.toLowerCase().includes(needle) || activity.actor.toLowerCase().includes(needle) || (activity.note ?? '').toLowerCase().includes(needle);
    });
  }, [filter, query]);
  const groups = useMemo(() => groupTimeline(visible), [visible]);
  const selected = allActivities.find(activity => activity.id === selectedId) ?? null;
  return <main className="w-full px-4 py-6 lg:px-8 lg:py-10" data-id="element-98" data-mp="2sxweull0lba1">
      <div className="mx-auto w-full max-w-[1104px] overflow-hidden rounded-lg border border-line bg-surface shadow-panel" data-id="element-99" data-mp="1cl7vkb0pqnvb">
        <TimelineToolbar filter={filter} counts={counts} query={query} onFilterChange={setFilter} onQueryChange={setQuery} data-id="element-100" data-mp="1hldjbg3v3q84" />

        <div className="flex" data-id="element-101" data-mp="3f97i9i8wt8r7">
          <div className="timeline-scroll max-h-[calc(100vh-180px)] min-h-[520px] flex-1 overflow-y-auto" data-id="element-102" data-mp="3f8y18k5uebxn">
            <TimelineList groups={groups} density={density} selectedId={selectedId} onSelect={setSelectedId} data-id="element-103" data-mp="3afd04j8yd1u8" />
          </div>

          <aside aria-label="Activity details" className="hidden max-h-[calc(100vh-180px)] min-h-[520px] w-[380px] shrink-0 border-l border-line bg-surface-muted lg:block" data-id="element-104" data-mp="30h5n2bhsb3xi">
            <ActivityDetail activity={selected} onClose={() => setSelectedId(null)} showClose={Boolean(selected)} data-id="element-105" data-mp="2rkevoce6gd99" />
          </aside>
        </div>
      </div>

      <AnimatePresence data-id="element-106" data-mp="ks49re2xrhda">
        {selected && <motion.div key="sheet" initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-x-0 bottom-0 z-40 max-h-[78vh] overflow-hidden rounded-t-xl border-t border-line bg-surface shadow-sheet lg:hidden" role="dialog" aria-modal="false" aria-label="Activity details" data-id="element-107" data-mp="ktfcrbok4l3c">
            <div className="h-[70vh] overflow-hidden" data-id="element-108" data-mp="9dkikboaji84">
              <ActivityDetail activity={selected} onClose={() => setSelectedId(null)} showClose data-id="element-109" data-mp="9f5bjwuyit3v" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </main>;
}